import { FC, useEffect } from 'react'
import { Row, Col, Text, Button } from '@/client/components'
import { useRouterPush } from '@/client/hooks'
import * as S from './styles'
import { BlogSearch, PostTag } from '../Components'
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const BlogHeader: FC<any> = ({
  blogLists,
  search_result = '',
  search_placeholder,
  no_results,
  tag_lists,
  sidebar,
  view_all
}) => {
  const { routerPush, query } = useRouterPush()
  useEffect(() => {}, [query])
  return (
    <Row>
      <Col lg={12}>
        <S.HeaderWrap>
          <Row isFull>
            <Col lg={7} noGutter>
              <S.BlogSearchWrapper>
                <BlogSearch search_placeholder={search_placeholder} search_result={search_result} />
              </S.BlogSearchWrapper>
            </Col>
            <Col lg={5}>
              {tag_lists && tag_lists.length > 0 && (
                <S.PopularTopics>
                  <Text as='p' size='lg' weight='medium' style={{ width: '100%' }}>
                    {sidebar['sidebar_header']}
                  </Text>

                  <S.PopularTopicsList>
                    <S.PostTagWrapper>
                      <PostTag tags={tag_lists} />
                    </S.PostTagWrapper>
                  </S.PopularTopicsList>
                </S.PopularTopics>
              )}
            </Col>
          </Row>
        </S.HeaderWrap>
      </Col>
      {query['id'] && blogLists.length > 0 && (
        <Col lg={12}>
          <Text as='h2' size='lg'>
            {search_result} <b>{query['id']}</b>
          </Text>
          <Button
            type='button'
            kind='action'
            className='subscribebutton'
            color='white'
            onClick={() => routerPush('/blog')}
          >
            {view_all ? view_all : 'View All'}
          </Button>
        </Col>
      )}
      {query['id'] && blogLists.length === 0 && (
        <Col lg={12}>
          <Text as='h2' size='lg'>
            {no_results}
          </Text>
          <Button
            type='button'
            kind='action'
            className='subscribebutton'
            color='white'
            onClick={() => routerPush('/blog')}
          >
            {view_all ? view_all : 'View All'}
          </Button>
        </Col>
      )}
    </Row>
  )
}
